
import { inject, Injectable } from '@angular/core';
import { ValidationService, IValidationRuleset } from '@aston/foundation';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as AppStoreSelectors from 'apps/console/src/app/root-store/app-store/selectors';

import { ConsoleDomainValidators } from '../enums/validators';

@Injectable({
	providedIn: 'root'
})
export class ConsoleValidationService extends ValidationService {

	private http = inject(HttpClient)
	private store = inject(Store)

	loadValidationRulesetInternal(): Observable<any> {
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get<IValidationRuleset>(`${config.apiUrl}/api/Validation`)),
			map(ruleset => this.useValidationRuleset(ruleset, ConsoleDomainValidators)),
			catchError(_ => {
				this.setValidationRulesetInError();
				return of({});
			})
		);
	}
}
